import styled from 'styled-components'

const MultiColumnFormContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  border-radius: 4px;
  margin-top: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
    height: 100%;
  }
`

export default MultiColumnFormContentContainer
